export default __webpack_public_path__ + "static/media/reverse_facebook.384bebcb.svg";